export default "This event is open to the public. Membership is not required.";